<div *ngIf="exibirBilhetes === false">
  <!-- Breadcrumb -->
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a routerLink="">Início</a>
    </li>
    <li class="breadcrumb-item">Minha Conta</li>
    <li class="breadcrumb-item active">
      Sorteios
    </li>
  </ol>
  <!-- //.Breadcrumb -->

  <h2 class="titulo-interna">Detalhe dos Sorteios</h2>

  <p>Cidadão: <strong>{{sorteio?.nomeConsumidor}}</strong></p>

  <p>Sorteio: <strong>{{sorteio?.nomeSorteio}}</strong></p>

  <p>Extra&ccedil;&atilde;o: <strong>{{sorteio?.desTipoSorteio}}</strong></p>

  <p>{{(escolherTexto(sorteio))}} <strong>{{escolherData(sorteio) | date:'dd/MM/yyyy'}} {{(observacaoSuspenso(sorteio))}}</strong></p>

  <p>Compras Válidas: <strong>{{sorteio?.quantidadesComprasValidas}}</strong></p>

  <!-- codSituacaoPremiacaoConsumidor == 1 - Atual; 4 - Homologado -->
  <div *ngIf="(sorteio?.codSituacaoPremiacaoConsumidor == 1 || sorteio?.codSituacaoPremiacaoConsumidor == 4) && sorteio?.valorTotalComprasValidas >=0 && sorteio?.codTipoSorteio != 2">
      <p>Valor Total de Compras Válidas: <strong>{{sorteio?.valorTotalComprasValidas | currency:'BRL':'symbol':'1.2-2' }}</strong></p>
  </div>

  <p *ngIf="sorteio?.participaSorteio == 1">Total de documentos no período: <strong>{{sorteio?.quantidadesComprasRealizadas}}</strong></p>
  
   <!-- Mensal -->
   <div *ngIf="sorteio?.participaSorteio == 1">
    <div *ngIf="sorteio?.codTipoSorteio == 1">
      <div *ngIf="sorteio?.previsaoBilhetes == 0">
          <p *ngIf="sorteio?.quantidadeBilhetes >= 0 && sorteio?.bilhetesGerados == true">Total de bilhetes gerados: <strong>{{sorteio?.quantidadeBilhetes}}</strong></p>
      </div>
    </div>
  </div>
  
   <!-- Especial -->
   <div *ngIf="sorteio?.participaSorteio == 1">
    <div *ngIf="sorteio?.codTipoSorteio == 2">
      <div *ngIf="sorteio?.quantidadeBilhetes > 0">
          <p>Total de bilhetes gerados: <strong>{{sorteio?.quantidadeBilhetes}}</strong></p>
      </div>
  </div>
</div>

  <div class="row" *ngIf="sorteio?.previsaoBilhetes > 0 && sorteio?.quantidadeBilhetes === 0 && sorteio?.bilhetesGerados == false">
    <div class="alert alert-primary col-sm-12">
      <span> Os bilhetes referentes ao mês atual serão gerados no início do mês subsequente.</span>
      <br>
      <span> Você tem até o momento o total de {{ sorteio?.previsaoBilhetes }} bilhetes para esse sorteio.</span>
    </div>
  </div>

  <p *ngIf="sorteio?.participaSorteio == 0" style="color: red"><strong>{{MensagemImpedidoCidadao}}</strong></p>

  <div class="row">
    <div class="col-sm-12">
      <button type="button" class="btn btn-bluelight" *ngIf="sorteio?.quantidadeBilhetes > 0" (click)="visualizarBilhetes()">Visualizar Bilhetes</button>
      <button type="button" class="btn btn-bluelight" (click)="detalhesSorteio(sorteio?.seqSorteio, true)">Dados Públicos</button>
      <button type="button" class="btn btn-secondary" (click)="voltar()">Voltar</button>
    </div>
  </div>
</div>

  <div *ngIf="exibirBilhetes === true">
    <app-consumidor-visualizar-bilhetes (OnVoltarClicked)="onVoltarBilhetesClicked($event)"></app-consumidor-visualizar-bilhetes>
  </div>



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-detalhe-sorteio/consumidor-detalhe-sorteio.component.html